<template lang="pug">
header#v-header
  img(src='@/assets/aws-summit-logo.png', alt='AWS SUMMIT TAIPEI', width='150')
</template>

<script>
export default {
  name: 'Header',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-header
  +background(url(~@/assets/header-background.png))
  +flex(null, center)
  height: 70px
  padding-left: 60px
  z-index: 99
</style>
